import React, { ReactNode, useContext } from "react";

export type CurrentLanguageType = 'foreign' | 'native'
export type SettingsStorageType = {
    deviceID: string | null | undefined,
    currentLanguage: CurrentLanguageType,
    darkMode: boolean,
}

export type SettingsStorageContextType = {
    settings: SettingsStorageType;
    setSettings: (settings: SettingsStorageType) => void;
}

type SettingsStorageProviderProps = {
    initialValue: SettingsStorageContextType;
    children: ReactNode | ReactNode[];
};

const settingsStorageContext = React.createContext<SettingsStorageContextType>({
    settings: {
        deviceID: undefined,
        currentLanguage: 'native',
        darkMode: false
    },
    setSettings: () => {},
});

export function useSettingsStorageContext() {
    return useContext(settingsStorageContext);
}

export default function SettingsStorageProvider({children, initialValue, ...rest}: SettingsStorageProviderProps) {
    return <settingsStorageContext.Provider value={initialValue}>{children}</settingsStorageContext.Provider>
}